<template>
  <v-container>
    <v-row justify="end">
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <div class="title">
              {{ this.$t('template_events.title') }} adsad
            </div>
            <v-spacer />
            <v-btn
              small
              rounded
              color="primary"
              v-text="this.$t('general.add')"
              @click="createEvent()"
            />
          </v-card-title>
          <v-divider />
          <v-data-table
            :headers="eventsTable.headers"
            :items="templateEvents"
            :search="eventsTable.search"
            :loading="eventsTable.loading"
          >
            <template v-if="templateEvents.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="text-no-wrap cursor-pointer" @click="showEvent(item.id)">
                    <v-icon
                      :color="item.status === 'active' ? 'success' : 'error'"
                      v-text="'fiber_manual_record'"
                      small
                      left
                    />
                    <span v-text="item.name" />
                  </td>
                  <td class="text-no-wrap cursor-pointer" @click="showEvent(item.id)">
                    <span v-text="item.type" class="text-uppercase" />
                  </td>
                  <td class="text-no-wrap cursor-pointer" @click="showEvent(item.id)">
                    <span v-text="item.account_type" class="text-uppercase" />
                  </td>
                  <td>
                    <v-menu
                      left
                      offset-y
                      nudge-bottom="10"
                      transition="slide-y-transition"
                      min-width="180px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon>
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="showEvent(item.id)">
                          Detalles
                        </v-list-item>
                        <v-list-item @click="editEvent(item.id)">
                          Editar
                        </v-list-item>
                        <v-list-item @click="idTemplateEventRemove = item.id">
                          Eliminar
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <BaseConfirmDialog
      v-if="idTemplateEventRemove"
      :title="'Eliminar evento de plantilla'"
      :description="'¿Está seguro que desea elimianr el evento de plantilla seleccionado?'"
      :cancel-text="'Cancelar'"
      :accept-text="'Aceptar'"
      @close="idTemplateEventRemove = null"
      @proceed="removeEvent()"
    />
    <TemplateEventDetail />
    <TemplateEventEditor />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BaseConfirmDialog from '@/components/BaseConfirmDialog'
import TemplateEventDetail from '@/components/Templates/TemplateEventDetail'
import TemplateEventEditor from '@/components/Templates/TemplateEventEditor'
export default {
  components: {
    BaseConfirmDialog,
    TemplateEventDetail,
    TemplateEventEditor
  },
  data () {
    return {
      idTemplateEventRemove: null,
      eventsTable: {
        loading: false,
        pagination: {},
        items: [],
        headers: [
          {
            text: this.$t('template_events.fields.name'),
            value: 'name',
            align: 'start',
            class: 'text-no-wrap blue--text text--darken-4',
            width: '0',
            sortable: true
          },
          {
            text: this.$t('template_events.fields.type'),
            value: 'type',
            align: 'start',
            class: 'text-no-wrap blue--text text--darken-4',
            width: '0px',
            sortable: true
          },
          {
            text: this.$t('template_events.fields.account_type'),
            value: 'account_type',
            align: 'start',
            class: 'text-no-wrap blue--text text--darken-4',
            width: '',
            sortable: true
          },
          {
            text: '',
            value: '',
            width: '0',
            sortable: false
          }
        ]
      }
    }
  },
  async created () {
    this.eventsTable.loading = true
    await this.getModules()
    await this.getTemplateEvents()
    this.eventsTable.loading = false
  },
  computed: {
    ...mapGetters({
      isOpenTemplateEventEditor: 'templateEvents/isOpenTemplateEventEditor',
      templateEvents: 'templateEvents/templateEvents',
      modules: 'templateEvents/modules'
    })
  },
  methods: {
    ...mapActions({
      getModules: 'templateEvents/getModules',
      getTemplateEvents: 'templateEvents/getTemplateEvents',
      getTemplateEvent: 'templateEvents/getTemplateEvent',
      deleteTemplateEvent: 'templateEvents/deleteTemplateEvent'
    }),
    ...mapMutations({
      setEditorMode: 'templateEvents/setEditorMode',
      toggleTemplateEventDetail: 'templateEvents/toggleTemplateEventDetail',
      toggleTemplateEventEditor: 'templateEvents/toggleTemplateEventEditor'
    }),
    async createEvent () {
      this.setEditorMode('create')
      this.toggleTemplateEventEditor(true)
    },
    async showEvent (id) {
      await this.getTemplateEvent({ id })
      this.toggleTemplateEventDetail(true)
    },
    async editEvent (id) {
      this.setEditorMode('edit')
      await this.getTemplateEvent({ id })
      this.toggleTemplateEventEditor(true)
    },
    async removeEvent () {
      await this.deleteTemplateEvent({ id: this.idTemplateEventRemove })
      this.idTemplateEventRemove = null
    }
  }
}
</script>
